import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import { default as ShopCommissions } from './ShopCommissions';
import ShopCommissionsContainer from './ShopCommissions.container';
import ShopCommissionsContainerBranched from './ShopCommissions.deviation_gruser.container';

export default withFeatureBranch({
  gruser_shop: ShopCommissionsContainerBranched(ShopCommissions),
})(ShopCommissionsContainer(ShopCommissions));
